import Splide, { Options, PaginationData, PaginationItem } from '@splidejs/splide';

// Ported from wwwroot/Static/javascript/helpers/carousel-transition-extension.ts for the TCSM react app.
// We need to extend the library (via its own documentation) and add our listeners inside the mount method
// because they are not automatically reattached when the slider is destroyed / remounted at different breakpoints
export const TransitionExtension = (splide: Splide) => {
	const inactivePageClass = 'carousel-page-inactive';
	const targetSlideClass = 'is-target';
	const originSlideClass = 'is-origin';
	const hideArrowsClass = 'hide-arrows';
	const classToTheRight = 'is-on-right';
	const classToTheLeft = 'is-on-left';

	const trackShift = (newIndex: number, oldIndex: number) => {
		const splideEls = splide.Components.Elements;
		splideEls.slides[oldIndex].classList.add(originSlideClass);
		splideEls.slides[newIndex].classList.add(targetSlideClass);

		const direction = newIndex - oldIndex > 0 ? 'right' : 'left';
		splideEls.root.setAttribute('data-slide-direction', direction);
		if (splideEls.slides[newIndex - 1]) {
			splideEls.slides[newIndex - 1].classList.add(classToTheLeft);
		}
		if (splideEls.slides[newIndex + 1]) {
			splideEls.slides[newIndex + 1].classList.add(classToTheRight);
		}
		if (splideEls.slides[oldIndex - 1]) {
			splideEls.slides[oldIndex - 1].classList.remove(classToTheLeft);
		}
		if (splideEls.slides[oldIndex + 1]) {
			splideEls.slides[oldIndex + 1].classList.remove(classToTheRight);
		}
	};

	const cleanupShift = () => {
		splide.Components.Elements.slides.forEach(slide => {
			slide.classList.remove(targetSlideClass);
			slide.classList.remove(originSlideClass);
		});
	};

	const updatePagination = (data: PaginationData, prevItem: PaginationItem, activeItem: PaginationItem) => {
		data.items.forEach(item => {
			if (item.button !== activeItem.button && (!prevItem || item.button !== prevItem.button)) {
				item.button.classList.add(inactivePageClass);
			} else {
				item.button.classList.remove(inactivePageClass);
			}
		});
	};

	const cleanupUnnecesaryArrows = (options: Options) => {
		const currentOptions = options || splide.options;
		const slideCount = splide.Components.Elements.slides.length;
		const { perPage } = currentOptions;
		if (perPage >= slideCount) {
			splide.Components.Elements.root.classList.add(hideArrowsClass);
		} else {
			splide.Components.Elements.root.classList.remove(hideArrowsClass);
		}
	};

	return {
		mount() {
			splide.on('move', trackShift);
			splide.on('moved', cleanupShift);
			splide.on('ready', cleanupUnnecesaryArrows);
			splide.on('updated', cleanupUnnecesaryArrows);
			splide.on('pagination:updated', updatePagination);
			if (splide.Components.Elements.slides[1]) {
				splide.Components.Elements.slides[1].classList.add(classToTheRight);
			}
		},
	};
};

export default TransitionExtension;
